export default __webpack_public_path__ + "static/media/new-sidebar-logo-close.f2c1b3b0.svg";